// removed by extract-text-webpack-plugin
module.exports = {"image":"Avatar__image___2JDo6"};